import { createRoot } from 'react-dom/client'
import { ThemeProvider } from 'next-themes'
import { AuthProvider } from './hooks/useAuth'
import { LanguageProvider } from './hooks/useLanguage'
import App from './App.tsx'
import './index.css'

console.log('🚀 Main.tsx: Starting app initialization...');

try {
  console.log('📱 Main.tsx: Creating React root...');
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  
  const root = createRoot(rootElement);
  
  console.log('🎨 Main.tsx: Rendering app with providers...');
  root.render(
  <AuthProvider>
    <LanguageProvider>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <App />
      </ThemeProvider>
    </LanguageProvider>
  </AuthProvider>
  );
  
  console.log('✅ Main.tsx: App rendered successfully!');
} catch (error) {
  console.error('❌ Main.tsx: Error during app initialization:', error);
  console.error('Stack:', error.stack);
}